// src/frontend/data/books/BlockchainFundamentals/data/cap5.js

const CAP5 = {
  id: 5,
  slug: "cap5-polygon",
  title: "Capítulo 5 — Polygon: escalabilidad para Ethereum y evolución a Polygon 2.0",
  sections: [
    {
      heading: "¿Qué es Polygon (antes Matic)?",
      text: [
        "Polygon es un proyecto de escalabilidad diseñado para mejorar el rendimiento de Ethereum sin abandonar su ecosistema.",
        "Permite que aplicaciones descentralizadas se ejecuten con menores comisiones y mayor velocidad, manteniendo compatibilidad con Ethereum.",
        "Polygon comenzó como Matic Network y evolucionó hacia una visión más amplia: un ecosistema multicadena interoperable."
      ]
    },
    {
      heading: "El problema de Ethereum que Polygon busca resolver",
      text: [
        "Desde 2017, Ethereum ha enfrentado serios problemas de escalabilidad.",
        "Durante el boom de las ICO, los NFT y las DeFi, la red operó cerca de su límite.",
        "Aplicaciones como CryptoKitties, Decentraland, Uniswap, AAVE y Curve incrementaron la congestión y las comisiones.",
        "Polygon surge como una solución práctica para aliviar esta sobrecarga sin abandonar Ethereum."
      ]
    },
    {
      heading: "Orígenes de Polygon (Matic Network)",
      text: [
        "Polygon fue fundado en 2018 por Jaynti Kanani, Sandeep Nailwal y Anurag Arjun.",
        "La idea inicial fue crear una sidechain Proof of Stake conectada a Ethereum mediante Plasma.",
        "Tras auditorías y rondas de financiación, la red Matic lanzó su primer bloque en mayo de 2020.",
        "En 2021, el proyecto se renombró oficialmente como Polygon."
      ]
    },
    {
      heading: "Arquitectura general de Polygon",
      text: [
        "Polygon funciona como una sidechain interoperable conectada a Ethereum.",
        "Utiliza Proof of Stake (PoS) para validación rápida y eficiente.",
        "Emplea Plasma para anclar seguridad a Ethereum mediante puntos de control (checkpoints)."
      ]
    },
    {
      heading: "Checkpoints y seguridad",
      text: [
        "Polygon envía periódicamente pruebas criptográficas (árboles Merkle) a Ethereum.",
        "Estos checkpoints aseguran que el estado de Polygon quede anclado en la mainnet.",
        "Esto reduce el almacenamiento local de nodos y mantiene la seguridad sin altos costos."
      ]
    },
    {
      heading: "Proof of Stake en Polygon",
      text: [
        "Los validadores hacen staking de tokens para participar en el consenso.",
        "El staking permite alta velocidad de bloques y costos de transacción mínimos.",
        "Cada bloque genera un árbol Merkle que resume las transacciones y se envía a Ethereum."
      ]
    },
    {
      heading: "Costos y rendimiento",
      text: [
        "Una transacción promedio en Ethereum puede costar varios dólares en picos de congestión.",
        "En Polygon, el costo suele ser del orden de fracciones de centavo.",
        "Esto habilita casos de uso imposibles en Ethereum L1, como microtransacciones."
      ]
    },
    {
      heading: "Polygon SDK: la visión multicadena",
      text: [
        "Polygon SDK es un conjunto de herramientas para crear blockchains compatibles con Ethereum.",
        "Convierte a Polygon en un ecosistema multicadena interoperable.",
        "Permite a desarrolladores desplegar cadenas personalizadas con diferentes modelos de consenso."
      ]
    },
    {
      heading: "Tipos de cadenas soportadas por Polygon SDK",
      list: [
        "Sidechains PoS conectadas a Ethereum.",
        "Sidechains standalone.",
        "Cadenas con ZK Rollups.",
        "Cadenas con Optimistic Rollups.",
        "Cadenas cerradas para empresas o instituciones.",
        "Sidechains interoperables entre sí."
      ]
    },
    {
      heading: "Polygon y los Rollups",
      text: [
        "Polygon ha apostado fuertemente por soluciones basadas en rollups.",
        "Los ZK Rollups ofrecen máxima seguridad y privacidad con pruebas criptográficas.",
        "Los Optimistic Rollups priorizan simplicidad y compatibilidad.",
        "Estas soluciones forman parte del futuro de la escalabilidad de Ethereum."
      ]
    },
    {
      heading: "Polygon 2.0 y el token POL",
      text: [
        "Polygon 2.0 representa una evolución del proyecto hacia una infraestructura unificada de rollups.",
        "El token POL reemplaza progresivamente a MATIC como token de utilidad y gobernanza.",
        "POL está diseñado como un token hiperinflacionario controlado para asegurar múltiples cadenas.",
        "Permite que un mismo validador participe en varias cadenas del ecosistema Polygon."
      ]
    },
    {
      heading: "Token MATIC / POL: funciones principales",
      list: [
        "Pago de comisiones de transacción.",
        "Staking y seguridad de la red.",
        "Gobernanza del ecosistema.",
        "Incentivos para validadores y desarrolladores.",
        "Interoperabilidad entre cadenas Polygon."
      ]
    },
    {
      heading: "Casos de uso reales",
      text: [
        "Polygon es ampliamente utilizado en DeFi, NFT, gaming y pagos.",
        "Numerosos protocolos migraron o desplegaron versiones en Polygon para reducir costos.",
        "Esto ha convertido a Polygon en una de las soluciones L2 más usadas de Ethereum."
      ]
    },
    {
      heading: "Proyectos destacados en Polygon",
      list: [
        "AAVE, Curve, SushiSwap, QuickSwap.",
        "1inch, Beefy Finance, PoolTogether.",
        "Decenas de juegos, marketplaces NFT y plataformas Web3."
      ]
    },
    {
      heading: "Ventajas de Polygon",
      list: [
        "Compatibilidad total con Ethereum (EVM).",
        "Comisiones extremadamente bajas.",
        "Alta velocidad de confirmación.",
        "Ecosistema maduro y ampliamente adoptado.",
        "Visión clara de escalabilidad a largo plazo."
      ]
    },
    {
      heading: "Trade-offs y críticas",
      text: [
        "La sidechain PoS no hereda completamente la seguridad de Ethereum.",
        "El número de validadores es menor que en Ethereum.",
        "Los puentes siguen siendo puntos críticos de riesgo.",
        "La complejidad del ecosistema aumenta la superficie de ataque."
      ]
    },
    {
      heading: "Buenas prácticas al usar Polygon",
      list: [
        "Verifica siempre la red antes de enviar fondos.",
        "Usa bridges oficiales y reconocidos.",
        "Envía primero transacciones de prueba.",
        "Comprende la diferencia entre sidechain y rollup.",
        "No asumas que bajo costo significa cero riesgo."
      ]
    },
    {
      heading: "Conclusión",
      text: [
        "Polygon es una pieza clave en la estrategia de escalabilidad de Ethereum.",
        "Ofrece una solución práctica, usable y adoptada para dApps de alto volumen.",
        "Con Polygon 2.0 y el token POL, el proyecto se posiciona como infraestructura central del futuro multicadena.",
        "Entender Polygon es entender cómo Ethereum escala en la práctica."
      ]
    }
  ]
};

export default CAP5;
